import { Component, inject } from '@angular/core';

import { AuthService } from '../../../auth/services/auth.service';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { AdminHeaderComponent } from '../admin-header/admin-header.component';
import { AdminSidebarComponent } from '../admin-sidebar/admin-sidebar.component';
import { AdminFooterComponent } from '../admin-footer/admin-footer.component';

@Component({
  selector: 'app-error-shell',
  imports: [HeaderComponent, FooterComponent, AdminHeaderComponent, AdminSidebarComponent, AdminFooterComponent],
  templateUrl: './error-shell.component.html',
  styleUrl: './error-shell.component.scss'
})
export class ErrorShellComponent {
  protected readonly authService = inject(AuthService);
}
